import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('error-index-1992f2b7bedbb8298-1'),
    routerUrl: '/error',
    resourceIcon: 'TeamOutlined',
    type: '2',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Error')),
    children: [
      //$MORE$
    ],
  },
];
